// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4027":"62fa4816fecf1b6b","6193":"e4417ceb39314cd5","8414":"0a5b66e7854c1461","9937":"4d6b1e618289a039"}[chunkId] + ".css";
};